import React, { Component } from 'react';
import { Button, Tabs } from 'antd';
import QRCode from 'qrcode.react';
import { Translation } from 'react-i18next';
import * as consts from '../consts';

const { TabPane } = Tabs;
const QR_TAB = '2';

class LoginComponent extends Component {
  constructor(props) {
    super(props);

    // this.email = React.createRef();
    // this.password = React.createRef();
    this.state = {
      activeTab: '1',
    };
    this.authQRStep1 = this.authQRStep1.bind(this);
  }

  componentDidMount() {
    this.authQRStep1();
  }

  authQRStep1() {
    const self = this.props;
    this.props.onLoginQR1Action({
      callback: () => {
        self.history.push(`${consts.PREFIX_FRONT_URL}/home`);
      },
    });
  }

  handleChangeTab(activeTab) {
    if (activeTab === QR_TAB && this.props.login.expired) {
      this.authQRStep1();
    }

    this.setState({ activeTab });
  }

  changeTab(activeTab) {
    this.setState({ activeTab });
  }

  render() {
    const { login } = this.props;
    const { activeTab } = this.state;

    return (
      <Translation>
        {(t) => (
          <div style={{
            width: '100%',
            height: '100vh',
            background: 'linear-gradient(to top, #1CB5E0 0%, #1C1741 100%)',
          }}
          >
            <div className="wrap-login-component">
              <div className="text-center">
                <img
                  src={require('../assets/imgs/truskey_text.png')}
                  style={{
                    objectFit: 'contain',
                    width: '257px',
                  }}
                />
              </div>
              <div
                className="text-center mt-small mb-medium"
                style={{
                  fontSize: '24px',
                }}
              >
                {t('login.login_trustkeys')}
              </div>
              <div className="form-wrap">
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  type="line"
                  size="large"
                  onChange={(tab) => this.handleChangeTab(tab)}
                  style={{ width: '100%' }}
                >
                  <TabPane tab={t('login.with_qr')} key="1" className="text-center">
                    <div>
                      {
                        login.expired ? (
                          <div className="relative">
                            <div className="z-1 abs-center">
                              <Button type="primary" onClick={this.authQRStep1}>
                                {t('login.new_qr')}
                              </Button>
                            </div>
                            {login.qrStep1.image
                              ? <img className="blur" src={`data:image/png;base64,${login.qrStep1.image}`} /> : ''}
                          </div>
                        )
                          : login.qrStep2.avatar
                            ? (
                              <>
                                <img
                                    style={{
                                      width: 96,
                                      height: 96,
                                      borderRadius: 100,
                                    }}
                                    src={login.qrStep2.avatar}
                                />
                                <div className="text-center">
                                  {login.qrStep2.display_name}
                                </div>
                                <div>
                                  {t('login.qr_success')}
                                </div>
                              </>
                            )
                            : (login.qrStep1.image
                              ? <img src={`data:image/png;base64,${login.qrStep1.image}`} /> : '')
                      }
                    </div>
                  </TabPane>
                  <TabPane tab={t('login.download_app')} key="2" className="text-center">
                    <QRCode
                      className="landing__banner-right"
                      value="https://crypto.mobilelab.vn/v1/cryptotrading/views/download?aHR0cHM6Ly9jcnlwdG8ubW9iaWxlbGFiLnZuL3YxL2NyeXB0b3RyYWRpbmcvdmlld3MvZG93bmxvYWQ="
                      size={219}
                      style={{ border: 'thick white solid', padding: 10 }}
                    />
                  </TabPane>
                </Tabs>
              </div>
              <div style={{ fontSize: 16, textAlign: 'center' }} className="pt-medium">
                <span className="">{t('login.not_have_account')}</span>
                {' '}
                <span className="link bold" style={{ color: '#fafafa' }} onClick={() => this.changeTab('2')}>
                  {t('login.download_trustkeys')}
                </span>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default LoginComponent;
